import React from "react";
import { storyblokEditable } from "@storyblok/react";
import { cn } from "@/storyblok/utils/cn";
import HeroSimpleImage from "@/library/components/images/HeroSimpleImage";

export default function HeroSimple({ blok }) {
  const { title, titleAs = "h1", images = {} } = blok;

  const TitleAs = titleAs;

  return (
    <section className="w-full">
      {images.length > 0 && (
        <div className="relative flex flex-col justify-center w-full h-[25vh] md:h-[30vh] md:object-center overflow-hidden">
          <HeroSimpleImage images={images} />
        </div>
      )}

      {title && (
        <div className="w-full bg-bg-color-dark py-4">
          <div className="container mx-auto px-4 max-w-7xl">
            <TitleAs className="max-w-7xl ml-5 sm:ml-16 md:ml-24 text-textLight text-xl md:text-2xl font-bold">
              {title}
            </TitleAs>
          </div>
        </div>
      )}
    </section>
  );
}
